// Decorative landmarks calibrated to this square portrait, not inference output.
// Both layers use a centred cover crop, so landmarks remain registered at any size.
export const faceReferencePoints = {
  browL: [360, 354], browLC: [410, 340], browLI: [453, 353],
  browRI: [537, 350], browRC: [579, 337], browR: [630, 352],
  eyeLO: [381, 383], eyeL: [415, 382], eyeLI: [451, 384],
  eyeRI: [539, 383], eyeR: [571, 379], eyeRO: [610, 382],
  bridge: [493, 389], noseL: [464, 477], nose: [496, 481], noseR: [529, 476],
  mouthL: [425, 540], lipL: [459, 535], lip: [496, 542], lipR: [530, 534], mouthR: [556, 539], lipB: [495, 568],
  cheekL: [330, 464], jawL: [353, 553], chinL: [414, 633], chin: [498, 669], chinR: [583, 630], jawR: [635, 551], cheekR: [666, 461],
} as const;
export const faceLandmarkEdges: [keyof typeof faceReferencePoints, keyof typeof faceReferencePoints][] = [
  ["browL","browLC"],["browLC","browLI"],["browRI","browRC"],["browRC","browR"],
  ["eyeLO","eyeL"],["eyeL","eyeLI"],["eyeRI","eyeR"],["eyeR","eyeRO"],
  ["browL","eyeLO"],["browLI","eyeLI"],["browRI","eyeRI"],["browR","eyeRO"],
  ["eyeLI","bridge"],["bridge","eyeRI"],["bridge","nose"],["eyeLO","cheekL"],["eyeRO","cheekR"],
  ["cheekL","noseL"],["noseL","nose"],["nose","noseR"],["noseR","cheekR"],
  ["cheekL","jawL"],["jawL","chinL"],["chinL","chin"],["chin","chinR"],["chinR","jawR"],["jawR","cheekR"],
  ["noseL","mouthL"],["nose","lip"],["noseR","mouthR"],
  ["mouthL","lipL"],["lipL","lip"],["lip","lipR"],["lipR","mouthR"],["mouthL","lipB"],["lipB","mouthR"],
  ["jawL","mouthL"],["mouthR","jawR"],["lipB","chin"],["mouthL","chinL"],["mouthR","chinR"],
];
// The second photo has a slight head turn; calibrate it independently.
export const faceSecondPoints = {
  browL: [373, 357], browLC: [424, 343], browLI: [469, 350],
  browRI: [550, 343], browRC: [597, 333], browR: [647, 344],
  eyeLO: [388, 382], eyeL: [423, 378], eyeLI: [457, 381],
  eyeRI: [547, 373], eyeR: [590, 371], eyeRO: [628, 374],
  bridge: [504, 383], noseL: [476, 484], nose: [513, 489], noseR: [540, 479],
  mouthL: [443, 542], lipL: [481, 533], lip: [516, 540], lipR: [550, 530], mouthR: [577, 534], lipB: [516, 567],
  cheekL: [336, 459], jawL: [349, 554], chinL: [423, 650], chin: [517, 684], chinR: [606, 641], jawR: [665, 541], cheekR: [680, 448],
} as const;
